import UserDetailsCard from './UserDetailsCard';

export default UserDetailsCard;
